import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';

@Component({
  selector: 'app-footer-link',
  templateUrl: './footer-link.component.html',
  styleUrl: './footer-link.component.scss',
  imports: [GcTextComponent, IpoTranslatePipe, RouterLink, NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterLinkComponent {
  readonly href = input<string>();
  readonly routerLink = input<string>();
  readonly openInNewTab = input(false); // New tab + screen-reader “opens in new tab” hint.
  readonly isPdfDocument = input(false); // Screen-reader hint that the link opens a PDF document.
}
